// extracted by mini-css-extract-plugin
module.exports = {"right-side-actions-desktop":"TopMenuRightSide_right-side-actions-desktop__DqkRG"};